import type { Sticker } from '../types';

export const creativity: Sticker[] = [
  {
    id: 22001,
    url: 'https://stickers.nauczniaczek.pl/colections/14601574-creativity/png/001-creativity.png',
    name: 'Kreatywność',
    category: 'creativity',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 22002,
    url: 'https://stickers.nauczniaczek.pl/colections/14601574-creativity/png/002-creativity.png',
    name: 'Pomysł',
    category: 'creativity',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 22003,
    url: 'https://stickers.nauczniaczek.pl/colections/14601574-creativity/png/003-creativity.png',
    name: 'Inspiracja',
    category: 'creativity',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 22004,
    url: 'https://stickers.nauczniaczek.pl/colections/14601574-creativity/png/004-creativity.png',
    name: 'Wyobraźnia',
    category: 'creativity',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 22005,
    url: 'https://stickers.nauczniaczek.pl/colections/14601574-creativity/png/005-creativity.png',
    name: 'Twórczość',
    category: 'creativity',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 22006,
    url: 'https://stickers.nauczniaczek.pl/colections/14601574-creativity/png/006-creativity.png',
    name: 'Sztuka',
    category: 'creativity',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 22007,
    url: 'https://stickers.nauczniaczek.pl/colections/14601574-creativity/png/007-creativity.png',
    name: 'Malowanie',
    category: 'creativity',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 22008,
    url: 'https://stickers.nauczniaczek.pl/colections/14601574-creativity/png/008-creativity.png',
    name: 'Rysowanie',
    category: 'creativity',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 22009,
    url: 'https://stickers.nauczniaczek.pl/colections/14601574-creativity/png/009-creativity.png',
    name: 'Projektowanie',
    category: 'creativity',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 22010,
    url: 'https://stickers.nauczniaczek.pl/colections/14601574-creativity/png/010-creativity.png',
    name: 'Innowacja',
    category: 'creativity',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 22011,
    url: 'https://stickers.nauczniaczek.pl/colections/14601574-creativity/png/011-creativity.png',
    name: 'Eksperyment',
    category: 'creativity',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 22012,
    url: 'https://stickers.nauczniaczek.pl/colections/14601574-creativity/png/012-creativity.png',
    name: 'Odkrywanie',
    category: 'creativity',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 22013,
    url: 'https://stickers.nauczniaczek.pl/colections/14601574-creativity/png/013-creativity.png',
    name: 'Rozwój',
    category: 'creativity',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 22014,
    url: 'https://stickers.nauczniaczek.pl/colections/14601574-creativity/png/014-creativity.png',
    name: 'Talent',
    category: 'creativity',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 22015,
    url: 'https://stickers.nauczniaczek.pl/colections/14601574-creativity/png/015-creativity.png',
    name: 'Pasja',
    category: 'creativity',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 22016,
    url: 'https://stickers.nauczniaczek.pl/colections/14601574-creativity/png/016-creativity.png',
    name: 'Warsztat',
    category: 'creativity',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 22017,
    url: 'https://stickers.nauczniaczek.pl/colections/14601574-creativity/png/017-creativity.png',
    name: 'Narzędzia',
    category: 'creativity',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 22018,
    url: 'https://stickers.nauczniaczek.pl/colections/14601574-creativity/png/018-creativity.png',
    name: 'Proces',
    category: 'creativity',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 22019,
    url: 'https://stickers.nauczniaczek.pl/colections/14601574-creativity/png/019-creativity.png',
    name: 'Wizja',
    category: 'creativity',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 22020,
    url: 'https://stickers.nauczniaczek.pl/colections/14601574-creativity/png/020-creativity.png',
    name: 'Kreacja',
    category: 'creativity',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  }
];